import { useRef, useState, useEffect, forwardRef } from 'react';
import JEditor from 'jodit-react';
import styled from '@emotion/styled';

interface EditorProps {
  value: string;
  onChange: (value: string) => void;
}

const Editor = forwardRef<any, EditorProps>((props, ref) => {
  const { value, onChange } = props;
  const [content, set_content] = useState<any>(value || "Start Typing");
  const config = {
    readonly: false,
    height: 400,
  };

  const handleUpdate = (event: any) => {
    const editorContent = event;
    onChange(editorContent);
    set_content(editorContent);
  };

  useEffect(() => {
    set_content(value); // Sync with prop changes
  }, [value]);

  return (
    <Wrapper>
      <JEditor
        ref={ref} // Safe ref via forwardRef
        value={content}
        config={config}
        onBlur={(e) => handleUpdate(e)}
        onChange={() => {}} // Keep as is
      />
    </Wrapper>
  );
});

export default Editor;

const Wrapper = styled.div`
  /* Add styles if needed */
`;